import styles from './page.module.css';
import GoAuraConsentToggle from "./GoAura/GoAuraConsentToggle";
import SellerSnapConsentToggle from './SellerSnap/SellerSnapConsentToggle';
import BqoolConsentToggle from './Bqool/BqoolConsentToggle';
import WFSIntegrationToggle from './wfs/WFSIntegrationToggle';

export default function IntegrationPage() {
  const isProduction = typeof window !== 'undefined' && window.location.host.includes('app.boxem.com');

  return (
    <div className={styles.container}>
      {!isProduction && <WFSIntegrationToggle />}
      <BqoolConsentToggle />
      <GoAuraConsentToggle />
      <SellerSnapConsentToggle />
    </div>
  );
}   